import { redirect } from "@tanstack/react-router";
import { toast } from "react-toastify";
import type { Role } from "../api/types";
import { getSession } from "../requests/getSession";
import { deleteSessionCookie } from "./session";

export const verifyRoles = async (roles: Role[]) => {
  const { data, error } = await getSession();

  if (error) {
    if (error.statusCode === 401) {
      toast.info("Sua sessão expirou. Por favor, faça login novamente.", {
        toastId: "expired-session",
      });

      await deleteSessionCookie();

      throw redirect({ to: "/" });
    }
  } else if (data && !roles.includes(data.role)) {
    throw redirect({ to: "/dashboard" });
  }

  return { me: data! };
};
